import $ from 'jquery';

// Click for dropdown
if( $( '.dropdown-el' ).length  || $( '.form-reveal' ).length ) {

  let $inputTarget = $( '.dropdown-el input:radio:checked' );

  $( document ).on( 'click', '.drop-down', function( e ) {
    e.preventDefault();
    e.stopPropagation();

    $( this ).toggleClass( 'expanded' );

    $( document ).on( 'click', () => {
      $( this ).removeClass( 'expanded' );
    });
  });

  $( document ).on( 'click', '.dropdown-el label', function( e ) {
    $inputTarget = $( '#'+ $( e.target ).attr( 'for' ) )
    $inputTarget.prop( 'checked', true );
    $inputTarget.trigger('change');
  } )
}

const filtersObject = {};
const filtersCityObj = {};

function getParameterByName(name, url) {
  if (!url) {
      url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};

let ogHeroText = $( '.hero .headline-1').html();
let heroText = $( '.hero .headline-1');
let query = window.location.search;
let cityQuery = getParameterByName('city');
let listingQuery = getParameterByName('listing');
let listingFilter = $('input[value="' + listingQuery + '"]');
let filterLabel = $( listingFilter ).next().html()
let params = {};

function results() {

  if( $( "input[name='view']:checked" ).val() == 'list' ) {

    let results = $( '.cpt-card' ).filter( function() {
        return $( this ).css( 'display' ) == 'flex'
    })

    let resultsCount = $( results ).length;

    $( '#results' ).html( resultsCount );

    // const filtered = results.filter( function ( item ) {

    //   if ( item > 0 ) {
    //     this.count++;
    //     return true;
    //   }
    //   return false;

    // }, { count: 0 } );


    //   $( filtered ).each( function( i ) {

    //     if( i >= 8 ) {
    //       $( this ).addClass('hide-loaded');
    //     } else {
    //       $( this ).removeClass('hide-loaded');
    //     }
    //   })

    $( 'input#home-models' ).attr( 'disabled', false )
    $( 'input#home-models' ).removeClass( 'disabled' )

  } else if ( $( "input[name='view']:checked" ).val() == 'map' ) {

    let results = $( '.marker' ).filter( function() {
        return $( this ).css( 'display' ) == 'flex'
    }).length

    $( '#results' ).html( results );

    $( 'input#home-models' ).attr( 'disabled', true )
    $( 'input#home-models' ).addClass( 'disabled' )

  }

}
results();

$( '.show-more' ).on( 'click', function( e ) {
  e.preventDefault();
  $( '#filters').toggleClass( 'close' );
  $( '.show-more' ).toggleClass( 'open' );
})

//this is the toggle for list/map view
$( 'input[ name="view" ]' ).on( 'change', function( e ) {
  e.preventDefault();
  let filterVal = $( this ).val();
  $( "[data-view]" ).addClass( 'hide' );

  $( "[ data-view='" + filterVal + "' ]").removeClass( 'hide' );
  $( '.filter input' ).trigger( 'change' );
  results();
})

//this is the view all on the card type i.e. quick possessions
$( '.view-all' ).on( 'click', function( e ) {
  e.preventDefault();
  $( 'input#map' ).attr( 'disabled', false );
  $( 'input#map' ).removeClass( 'disabled' );
  delete params[ 'listing' ];
  pushParams();

  if( $( this ).attr( 'name' ) == 'listing' ) {

    $( heroText ).html( ogHeroText );
    $( '.filter input[ name="listing"]:checked' ).prop('checked', false);
    $( '.cpt-card, .marker, .cpt-card-title' ).removeClass( 'hide-listing' );
    delete filtersObject[ 'listing' ];
  } else if ( $( this ).attr( 'for' ) == 'all-communities'  ) {
    $( '.filter input[ for="all-communities"]:checked' ).prop('checked', true);
    $( '.cpt-card, .marker' ).removeClass( 'hide-communities' );
    delete filtersObject[ 'communities' ];
  }
  results();
})

//main filtering change handler
$( '.filter input, select' ).on( 'change', function() {
  let filterName = $( this ).attr( 'name' );
  let filterVal = $( this ).val();
  let filterVals = [];

  if ( filterVal == '') {
    delete filtersObject[ filterName ];
  } else if( $( this ).attr( 'name' ) == 'city' ) {

    $( 'input[name=' + filterName + ']' ).each( function() {
      let radioVal = $( this ).val();
      $( '.view-all' ).trigger('click');
      $( '.input-wrapper, .dropdown-el' ).removeClass('expanded');

      if( $( this ).prop( 'checked' ) === true ) {
        filtersObject[ radioVal ] = 'true';
        filtersCityObj[ radioVal ] = 'true';
        params[ filterName ] = filterVal;

      } else {
        $( '.cpt-card, .marker, .filter-city' ).removeClass( 'hide-' + radioVal );

        delete filtersObject[ radioVal ];
        delete filtersCityObj[ radioVal ];
      }
    })

  } else if( $( this ).attr( 'name' ) == 'listing' ) {

    let filterLabel = $( this ).next().html()

    if( $( this ).prop( 'checked' ) === true ) {
      $( heroText ).html( filterLabel );

      if( $( this ).val() === 'home-models' ) {
        $( 'input#map' ).attr( 'disabled', true );
        $( 'input#map' ).addClass( 'disabled' );
      } else {
        $( 'input#map' ).attr( 'disabled', false );
        $( 'input#map' ).removeClass( 'disabled' );
      }
      $( '.cpt-card-title' ).addClass( 'hide-listing' );
      filtersObject[ filterName ] = filterVal;
      params[ filterName ] = filterVal;

    } else {
      $( '.cpt-card-title' ).removeClass( 'hide-listing' );
      delete filtersObject[ filterName ];
    }


  } else if( $( this ).attr( 'type' ) == 'radio' ) {

    if( $( this ).val() == 'view-all' ) {
      $( '.cpt-card, .marker' ).removeClass( 'hide-communities' );
      delete filtersObject[ filterName ];
    } else if( $( this ).prop( 'checked' ) === true ) {
      filtersObject[ filterName ] = filterVal;
    } else {
      delete filtersObject[ filterName ];
    }

  } else if( $( this ).attr( 'type' ) == 'checkbox' ) {

    filterVals = $('input:checkbox[name=' + filterName + ']:checked').map(function() {
      return this.value;
    }).get();
    if ( !filterVals || !filterVals.length ) {

     $( '.cpt-card, .marker' ).removeClass( 'hide-' + filterName );

      delete filtersObject[ filterName ];
    } else {
      filtersObject[ filterName ] = filterVals;
    }
  } else if( $( this ).attr( 'type' ) == 'range') {

    let lowerSlider = document.querySelector( '.filter-lower' );
    let upperSlider = document.querySelector( '.filter-upper' );
    let lowerVal = parseInt( lowerSlider.value );
    let upperVal = parseInt( upperSlider.value );

    $( '.cpt-card, .marker' ).each( function() {

      if ( lowerVal <= $( this ).data( filterName ) && upperVal >= $( this ).data( filterName ) ) {
        filtersObject[ filterName ] = 'true';
        $( this ).attr( 'data-' + filterName, 'true' )
      } else {
        $( this ).attr( 'data-' + filterName, 'false' )
      }
    })
    $( upperSlider ).on( 'input' , function() {
      lowerVal = parseInt(lowerSlider.value);
      upperVal = parseInt(upperSlider.value);

      $( '#upper-val' ).html( upperSlider.value );

      if (upperVal < lowerVal + 1) {
         lowerSlider.value = upperVal - 1;
         $( '#lower-val' ).html( lowerSlider.value );
         if (lowerVal == lowerSlider.min) {
            upperSlider.value = 1;
         }
      }
   });

   $( lowerSlider ).on( 'input' , function() {
      lowerVal = parseInt( lowerSlider.value );
      upperVal = parseInt( upperSlider.value );

      $( '#lower-val' ).html( lowerSlider.value );

      if (lowerVal > upperVal - 1) {
       upperSlider.value = lowerVal + 1;
       $( '#upper-val' ).html( upperSlider.value );

       if (upperVal == upperSlider.max) {
         lowerSlider.value = parseInt(upperSlider.max) - 1;

       }
     }
   });
  };

  for (let key in filtersObject) {
    if (filtersObject.hasOwnProperty(key)) {
      let filtersKey = [];

      if( typeof filtersObject[ key ] == 'object' ) {

        $.each( filtersObject[ key ], function( i, value) {
          filtersKey += "[ data-" + key + "='" + value + "' ]";
        });
        if( filtersKey.length !== 0 ) {
          filtersKey = filtersKey.split('][').join('],[');
        }

      } else if ( key === 'communities' ) {
        filtersKey += "[ data-" + filtersObject[ key ] + "='true' ]";
      } else {
        filtersKey += "[ data-" + key + "='" + filtersObject[ key ] + "' ]";
      }

      if( key ===  'edmonton' || key === 'calgary' ) {
        $( '.filter-city' ).addClass( 'hide-' + key );
        $( '.filter-city' ).filter( filtersKey ).removeClass( 'hide-' + key );
      }

      console.log('adding hide-' + key);
      $( '.cpt-card, .marker' ).addClass( 'hide-' + key );

      console.log('removing hide-' + key + ' from ' , filtersKey);
      $( '.cpt-card, .marker' ).filter( filtersKey ).removeClass( 'hide-' + key );
    }
  }
  results();
  pushParams();
});

function pushParams() {
  let hash = window.location.hash;
  let paramString = new URLSearchParams( params ).toString()
  history.pushState( null, '', '?' + paramString + hash  );

  if( hash == '#!thanks' ) {
    $( '.qp-contact' )[0].click()
    history.replaceState( null, '', '?' + paramString + '#!thanks'  );
  }
}

function readQuery() {

  if( !cityQuery ) {
    cityQuery = 'calgary'
  }
  if( !listingQuery ) {
    listingQuery = 'home-models'
  }
  $( 'input:radio[ value="' + cityQuery +'" ]' ).attr('checked', true).trigger( 'change' );
  $( 'input:radio[ value="' + listingQuery +'" ]' ).attr('checked', true).trigger( 'change' );

}

readQuery();

// if( $( '.load-more.button' ).length ) {
//   $( '.load-more.button' ).on( 'click', function ( e ) {
//     e.preventDefault();
//     $( '.cpt-card' ).removeClass( 'hide-load' );
//     $( '.load-more.button' ).addClass( 'hide-load' );
//   });
// }

//this is the clear all to reset all filters
$( '#clear-all' ).on( 'click', function( e ) {
  e.preventDefault();

  $( heroText ).html( ogHeroText );

  $( '.filter:not( .filter-cities ) input' ).prop('checked', false).trigger( 'change' );
  $( '.filter-upper' ).val( '5000' ).trigger( 'change' );
  $( '.filter-lower' ).val( '0' ).trigger( 'change' );
  $( '.view-all' ).trigger( 'click' );
  $( '.input-wrapper' ).removeClass( 'expanded' );
  delete params[ 'listing' ];
  pushParams();
})

//SHOWHOME SFP FILTER
if( $( '.sfp-button' ).length ) {
  $( '.sfp-button' ).on( 'click', ( e ) => {
    let sfpFilter = $( e.currentTarget ).data( 'sfp' )
    let sfpImage = $( `.sfp-image[data-sfp='${ sfpFilter }']` )
    let sfpButton = $( `.sfp-button[data-sfp='${ sfpFilter }']` )

    $( '.sfp-image' ).removeClass( 'active' )
    $( '.sfp-button' ).removeClass( 'active' )
    $( sfpImage ).addClass( 'active' )
    $( sfpButton ).addClass( 'active' )
  } )
}